import { Card, Skeleton } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import React from "react";
import ReactApexChart from "react-apexcharts";

const Purpose = ({ data, loading, title, type }) => {

  return (
    <MDBox mb={3}>
      <Card sx={{ padding: "1rem" }}>
        <MDTypography variant="button" fontWeight="bold" color={"text"}>
          {title}
        </MDTypography>
        {loading && <Skeleton variant="rectangular" height={230} sx={{ borderRadius: 2 }} />}
        {!loading && data && (
          <ReactApexChart options={data?.options} series={data?.series} type={type} height={270} />
        )}
      </Card>
    </MDBox>
  );
};

export default Purpose;
